
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from "moment";

export const RoadWorkUploadExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />
            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={searchName == "Junior / Deputy Engineer" ? 8 : 6} style={{ textAlign: 'center', fontSize: 16, border: '1px solid black' }}>{name}</th>
                </tr>
                {/* <tr><td></td></tr> */}

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff" }}>
                        <th style={{ borderLeft: "1px solid black" }}>Sr.No.</th>
                        <th style={{ borderLeft: "1px solid white" }}>Location Name</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Area</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Name</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Number</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Upload Date</th>

                        {
                            searchName == "Junior / Deputy Engineer" ?
                                <>
                                    <th style={{ borderLeft: "1px solid white" }}>JE Name</th>
                                    <th style={{ borderLeft: "1px solid white" }}>DE Name</th>
                                </>
                                : ''
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                            <tr style={{ textAlign: "center", border: '1px solid black' }}>
                                <td >{item.rowNum}</td>
                                <td>{item.locationName ? item.locationName : '-'}</td>
                                <td>{item.workArea ? item.workArea : '-'}</td>
                                <td>{item.workName ? item.workName : '-'}</td>
                                <td>{item.workNumber ? item.workNumber : '-'}</td>
                                <td>{item.workUploadDate ? moment(item.workUploadDate).format("DD-MM-YYYY") : '-'}</td>
                                {
                                    searchName == "Junior / Deputy Engineer" ?
                                        <>
                                            <td>{item.uploadByJE ? item.uploadByJE : '-'}</td>
                                            <td>{item.uploadByDE ? item.uploadByDE : '-'}</td>
                                        </>
                                        : ''
                                }
                            </tr>
                        )) : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}